import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AuthLayout from './AuthLayout';
import { signup, socialLogin } from '../../services/authService';
import { clearResponseMessage, setErrorMessage } from '../../actions/messageActions';
import classNames from 'classnames';
import { getOnboardingDetails } from '../../services/onboardingService';
import { trackActivity } from '../../services/analyticsService';

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      isAcceptTerms: true,
      isShowPassword: false
    };
  }

  componentDidMount() {
    trackActivity('navigation: signup');
    this.props.clearResponseMessage();
  }

  componentWillUnmount() {
    this.props.clearResponseMessage();
  }

  handlefirstNameInputChange = (e) => {
    const firstName = e.target.value;
    this.setState({ firstName });
  };

  handlelastNameInputChange = (e) => {
    const lastName = e.target.value;
    this.setState({ lastName });
  };

  handleEmailInputChange = (e) => {
    const email = e.target.value;
    this.setState({ email });
  };

  handlePasswordInputChange = (e) => {
    const password = e.target.value;
    this.setState({ password });
  };

  handleConfirmPasswordInputChange = (e) => {
    const confirmPassword = e.target.value;
    this.setState({ confirmPassword });
  };

  handleAcceptCheckboxChange = (e) => {
    const isAcceptTerms = e.target.checked;
    this.setState({ isAcceptTerms });
  };

  toggleIsShowPassword = () => {
    let isShowPassword = this.state.isShowPassword;
    isShowPassword = !isShowPassword;
    this.setState({ isShowPassword });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, password, confirmPassword, isAcceptTerms } = this.state;
    const signupObj = {
      firstname: firstName,
      lastname: lastName,
      email: email,
      password: password,
      confirmPassword: confirmPassword
    };
    if (isAcceptTerms) {
      const result = await this.props.signup(signupObj);
      if (result === true) {
        this.trackSignUpAnalytics(email, 'email');
        this.props.history.push('/onboarding');
      }
    } else {
      this.props.setErrorMessage('Terms of services is not accepted');
    }
  };

  onLoginClick = () => {
    this.props.history.push('/login');
  };

  onSocialLoginClick = async (provider) => {
    const result = await this.props.socialLogin(provider);
    if (result) {
      this.trackSignUpAnalytics(result.email, provider);
      const onboardingData = await this.props.getOnboardingDetails();
      if (onboardingData && onboardingData.user_type) {
        this.props.history.push('/dashboard');
      } else {
        this.props.history.push('/onboarding');
      }
    }
  };

  renderErrors() {
    const { resError } = this.props.message;
    if (resError) {
      return <div className='alert-message'>{resError}</div>;
    }
  }

  renderSuccess() {
    const { resSuccess } = this.props.message;
    if (resSuccess) {
      return <div className='success-message'>{resSuccess}</div>;
    }
  }

  trackSignUpAnalytics = (email, type) => {
    let properties;
    if (email) properties = { email: email };
    if (type) properties = { ...properties, type: type }
    trackActivity('signed up', properties);
  }

  render() {
    const { loading } = this.props.auth;
    const { firstName, lastName, email, password, confirmPassword, isAcceptTerms, isShowPassword } = this.state;
    return (
      <>
        <AuthLayout>
          <div className='rightbar-inner'>
            <div className='login-rightbar-head'>
              <a className='w-inline-block'>
                <img src={require('../../assets/images/triplogo.png')} alt='' />
              </a>
            </div>
            <div className='login-rightbar-content regi'>
              <div className='register-wrapper'>
                <h3 className='signup-text'>Register</h3>
                <div className='form-block'>
                  <form name='wf-form-Signup-Form' onSubmit={this.onSubmit}>
                    <div className='form-row'>
                      <div className='form-col mb'>
                        <label htmlFor='First-Name' className='form-lable'>
                          First Name
                        </label>
                        <input
                          type='text'
                          className='form-input w-input'
                          maxLength='256'
                          name='firstName'
                          placeholder='John'
                          required=''
                          value={firstName}
                          onChange={this.handlefirstNameInputChange}
                        />
                      </div>
                      <div className='form-col'>
                        <label htmlFor='Last-Name' className='form-lable'>
                          Last Name
                        </label>
                        <input
                          type='text'
                          className='form-input w-input'
                          maxLength='256'
                          name='lastName'
                          placeholder='Doe'
                          required=''
                          value={lastName}
                          onChange={this.handlelastNameInputChange}
                        />
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label htmlFor='Email-7' className='form-lable'>
                          Email
                        </label>
                        <div className='input-block'>
                          <input
                            type='email'
                            className='form-input w-input'
                            maxLength='256'
                            name='email'
                            placeholder='venkat@tradeanalyst.com'
                            required=''
                            value={email}
                            onChange={this.handleEmailInputChange}
                          />
                          <div className='user-icon'></div>
                        </div>
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label htmlFor='name-3' className='form-lable'>
                          Password
                        </label>
                        <div className='input-block'>
                          <input
                            type={isShowPassword ? 'text' : 'password'}
                            className='form-input w-input'
                            maxLength='256'
                            name='password'
                            required=''
                            value={password}
                            onChange={this.handlePasswordInputChange}
                          />
                          <div
                            className={classNames('eye-icon', {
                              off: isShowPassword
                            })}
                            onClick={this.toggleIsShowPassword}></div>
                        </div>
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <label htmlFor='name-3' className='form-lable'>
                          Confirm Password
                        </label>
                        <div className='input-block'>
                          <input
                            type={isShowPassword ? 'text' : 'password'}
                            className='form-input w-input'
                            maxLength='256'
                            name='confirmPassword'
                            required=''
                            value={confirmPassword}
                            onChange={this.handleConfirmPasswordInputChange}
                          />
                          <div
                            className={classNames('eye-icon', {
                              off: isShowPassword
                            })}
                            onClick={this.toggleIsShowPassword}></div>
                        </div>
                      </div>
                    </div>
                    <div className='form-row'>
                      <div className='form-col'>
                        <div className='forgot-block mb'>
                          <div className='w-embed'>
                            <label className='checkbox-field'>
                              I accept <a style={{color:"#999"}} href="https://trip-note-pro.webflow.io/terms-of-service">Terms of Services</a>
                              <input
                                type='checkbox'
                                name='checkbox'
                                checked={isAcceptTerms}
                                onChange={this.handleAcceptCheckboxChange}
                              />
                              <span className='checkbox-span-rem'></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.renderErrors()}
                    {this.renderSuccess()}
                    <div
                      className={classNames('form-btn-block', {
                        'mc-loading': loading === true
                      })}>
                      <button
                        type='submit'
                        data-wait='Please wait...'
                        className='btn-square w-button'
                        disabled={loading}>
                        Register
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className='social-signup-wrapper'>
                <p className='social-signup-text'>Or continue with Social Sign On</p>
                <a
                  className='social-link-block social-login w-inline-block'
                  onClick={() => {
                    this.onSocialLoginClick('google.com');
                  }}>
                  <img src={require('../../assets/images/googleicon.svg')} alt='' />
                  <p className='social-text'>Continue with Google</p>
                </a>
                {/* <a className='social-link-block social-login d-none w-inline-block'>
                  <img src={require('../../assets/images/facebookicon.svg')} alt='' />
                  <p className='social-text'>Continue with Facebook</p>
                </a>
                <a className='social-link-block social-login d-none w-inline-block'>
                  <img src={require('../../assets/images/twittericon.svg')} alt='' />
                  <p className='social-text'>Continue with Twitter</p>
                </a> */}
              </div>
              <div className='login-rightbar-bottom'>
                <p className='rightbar-btm-text'>
                  Already have an account?{' '}
                  <a className='btm-link' onClick={this.onLoginClick} disabled={loading}>
                    Sign In Here
                  </a>
                </p>
              </div>
            </div>
          </div>
        </AuthLayout>
      </>
    );
  }
}

Signup.propTypes = {
  auth: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  message: state.message
});

export default connect(mapStateToProps, {
  signup,
  clearResponseMessage,
  setErrorMessage,
  socialLogin,
  getOnboardingDetails
})(Signup);
